import { useSelector } from 'core/use-cases/utilities/';

export const useDefaultAddress = () => {
  const { data } = useSelector((state) => state.shippingModel);

  return data.default.delivery.address;
};
